import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useLocale } from "../../context/LocaleContext";
import { track } from "../../lib/analytics";
import { Mascot } from "../../components/Mascot";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import Seo from "../../components/Seo";

export default function RegisterPage() {
  const { register, formatApiError } = useAuth();
  const { t, lp } = useLocale();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await register(name, email, password);
      track("signup");
      navigate(lp("/dashboard"));
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  }

  return (
    <div className="container-page flex min-h-[80vh] items-center justify-center py-12">
      <Seo title={`${t("register")} | LIVYVIO`} />
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <div className="flex items-center gap-2"><Mascot className="h-8 w-8" /><span className="font-heading text-xl font-extrabold">LIVYVIO</span></div>
        <h1 className="mt-6 font-heading text-2xl font-extrabold text-slate-900">{t("register")}</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label htmlFor="name">{t("name")}</Label><Input id="name" data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5" /></div>
          <div><Label htmlFor="email">{t("email")}</Label><Input id="email" data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" /></div>
          <div><Label htmlFor="password">{t("password")}</Label><Input id="password" data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" /></div>
          {error && <p data-testid="register-error" className="text-sm text-red-600">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="register-submit" className="w-full rounded-full bg-emerald-600 hover:bg-emerald-700">{busy ? "…" : t("register")}</Button>
        </form>
        <p className="mt-4 text-center text-sm text-slate-500">
          {t("login")}? <Link to={lp("/login")} className="font-semibold text-emerald-700">{t("login")}</Link>
        </p>
      </div>
    </div>
  );
}
